<template>
  <div v-if="showBanner" class="cookie-banner">
    <div class="cookie-banner-content">
      <fa icon="cookie-bite" size="lg"></fa>
      <span>This site uses operational cookies that are essential for the site to function. By continuing to use this site you agree to our use of cookies.</span>
    </div>
    <b-button class="got-it-button" type="is-primary" @click="dismiss">Got it</b-button>
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'CookieBanner',
  data() {
    return {
      dismissed: false,
    }
  },
  computed: {
    loggedInUser() {
      return this.$store.getters['user/loggedInUser'];
    },
    isLoggedIn() {
      return this.$store.state.user.loggedInUser.state.state === 'SIGNED_IN';
    },
    alreadyAcknowledged() {
      return this.loggedInUser && this.loggedInUser.preferences && this.loggedInUser.preferences.cookieBannerAcknowledged === true;
    },
    showBanner() {
      return this.isLoggedIn && this.isExternalUser && !this.alreadyAcknowledged && !this.dismissed;
    },
    isExternalUser() {
      return this.$store.getters['user/isExternalCompany'];
    },
  },
  methods: {
    async dismiss() {
      await this.$store.dispatch('user/cookieBannerAcknowledged', {
        user: this.loggedInUser,
      });

      this.dismissed = true;
    }
  }
}
</script>

<style lang="scss">

.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background-color: $primary;
  color: $primary-font-color;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.2);

  @media only screen and (max-width: $phone) {
    flex-direction: column;
    align-items: flex-start;
  }

  .cookie-banner-content {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .got-it-button{
    border: 2px solid transparent;
    border-radius: 4px;
    color: $white;
    background-color: $accent;
  }
  .got-it-button:hover{
    border: 2px solid transparent;
    border-radius: 4px;
    color: $white;
    background-color: $accent;
  }
}
</style>